import store from "../../../store"
import { taskApi } from "../../../tasks/api"
import { TaskViewModel } from "../../../tasks/api/task"

export const prefetchSubTasks = async (taskId: string) => {
  const prefetchOptions = { ifOlderThan: 10 } // prefetch if data is older than 10 seconds
  const action = taskApi.util.prefetch("getTasks", { task: taskId }, prefetchOptions)
  store.dispatch(action)
}

const fetchSubTasks = async (taskId: string) => {
  const action = taskApi.endpoints.getTasks.initiate(
    { task: taskId },
    {
      forceRefetch: true,
      subscribe: false,
    }
  )
  const actionResult = store.dispatch(action)
  return await actionResult.unwrap()
}

export const ensureSubTasks = async (taskId: string): Promise<TaskViewModel[]> => {
  const selector = taskApi.endpoints.getTasks.select({ task: taskId })
  const { data } = selector(store.getState())
  if (data) return data
  return await fetchSubTasks(taskId)
}
